module.exports = __webpack_public_path__ + "static/media/Upload button inactive.2fdaf41e.svg";